import { Header } from "@/components/header";
import { Footer } from "@/components/footer";
import { MustKnowLawsSection } from "@/components/must-know-laws-section";

export default function MustKnowLaws() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <MustKnowLawsSection />
      </main>
      <Footer />
    </div>
  );
}

